"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotViewModel = void 0;
const ko = __importStar(require("knockout"));
class SlotViewModel {
    constructor(slotModelParams, calVModel, configuration, stringsProvider) {
        this.slotModelParams = slotModelParams;
        this.calVModel = calVModel;
        this.configuration = configuration;
        this.stringsProvider = stringsProvider;
        this.dateId = slotModelParams.dateId;
        this.slotId = slotModelParams.slotSource.id;
        this.slotIndex = slotModelParams.slotIndex;
        this.dayIndex = slotModelParams.dayIndex;
        this.enabled = (slotModelParams.slotSource.disabled === true ? false : true);
        this.hasFocus = ko.observable(false).extend({ deferred: true });
        this.tabIndex = ko.observable(-1).extend({ deferred: true });
    }
    getLabel() {
        return this.stringsProvider.getString(this.slotId + ':label');
    }
    ;
    getPrice() {
        return this.stringsProvider.getString(this.slotId + ':price') || '';
    }
    ;
    isSelected() {
        return ko.computed(function () {
            return this._isSelected();
        }, this);
    }
    _isSelected() {
        return this.calVModel.selectedSlotIndexes().indexOf(this.slotIndex) !== -1;
    }
    focus(isNoHighlight) {
        this.tabIndex = ko.observable(0);
        if (!isNoHighlight) {
            this.hasFocus = ko.observable(true);
        }
    }
    ;
    blur() {
        this.hasFocus = ko.observable(false);
        this.tabIndex = ko.observable(-1);
    }
    ;
    select() {
        let selectionType;
        // allow disabled slot selection if allowDisabledSlotSelection is true.
        if ((this.enabled === false) && !this.configuration.allowDisabledSlotSelection) {
            return true;
        }
        if (this.calVModel.preselectedSlotIndexes.length === 0 && this._isSelected() === true) {
            this.calVModel.selectedSlotIndexes.remove(this.slotIndex);
            selectionType = 'deselect';
        }
        else if (this.configuration.deselectLastSlot === true &&
            this.calVModel.selectedSlotIndexes().length >= this.configuration.numOfSelection) {
            this.calVModel.selectedSlotIndexes().pop();
            this.calVModel.selectedSlotIndexes.push(this.slotIndex);
            selectionType = 'select';
        }
        else if (this.calVModel.selectedSlotIndexes().length < this.configuration.numOfSelection) {
            this.calVModel.selectedSlotIndexes.push(this.slotIndex);
            selectionType = 'select';
        }
        // trigger events and re-run slotIndexOfPreferences
        if (selectionType === 'select') {
            this.calVModel.slotIndexOfPreferences();
            this.calVModel.calendarEvents.slotSelected({
                dateId: this.dateId,
                slotId: this.slotId,
                isActive: this.enabled
            });
        }
        else if (selectionType === 'deselect') {
            this.calVModel.slotIndexOfPreferences();
            this.calVModel.calendarEvents.slotDeselected({
                dateId: this.dateId,
                slotId: this.slotId,
                isActive: this.enabled
            });
        }
        this.calVModel.sectionSlots.activeSlot(this);
        return true;
    }
    ;
}
exports.SlotViewModel = SlotViewModel;
